export const actionTypesLogin = {
    login: "LOGIN"
};
